import Input from "../../components/common/input";
import React, {useState} from "react";
import Selector from "../../components/common/selector";
import UserForm from "../../components/userForm";
import PropTypes from "prop-types";
import {PROGRAM_ASSOCIATION_LABEL, SUPERUSER_PERMISSION_ID} from "../../constants";
import FormCheckbox from "../../components/common/formCheckbox";
import SendPasswordLink from "./sendPasswordLink";
import {isUserASuperUser} from "../../utils/users";

const PERMISSIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Counselor',
    value: 'Counselor'
  },
  {
    label: 'Teacher',
    value: 'Teacher'
  },
  {
    label: 'School Administrator',
    value: 'School Administrator'
  },
  {
    label: 'District Administrator',
    value: 'District Administrator'
  },
  {
    label: 'Academic Prep Partner',
    value: 'Academic Prep Partner'
  },
  {
    label: 'Registrar',
    value: 'Registrar'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

const PROGRAMS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Program 1',
    value: 'Program 1'
  },
  {
    label: 'Program 2',
    value: 'Program 2'
  },
  {
    label: 'Program 3',
    value: 'Program 3'
  },
  {
    label: 'Program 4',
    value: 'Program 4'
  },
  {
    label: 'Program 5',
    value: 'Program 5'
  },
  {
    label: 'Program 6',
    value: 'Program 6'
  },
  {
    label: 'Program 7',
    value: 'Program 7'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

const EditUserProfile = (props) => {
  const {
    errors,
    userProfile,
    onSubmitAction,
    onCancelAction,
    sendResetPasswordAction
  } = props;

  const [email, setEmail] = useState(userProfile.user.username);
  const [firstName, setFirstName] = useState(userProfile.user.firstName);
  const [lastName, setLastName] = useState(userProfile.user.lastName);
  const [role, setRole] = useState((userProfile.userRole) ? userProfile.userRole.id : '');
  const [programAssociation, setProgramAssociation] = useState((userProfile.program) ? userProfile.program.id : '');
  const [enabled, setEnabled] = useState(!!(userProfile.user.enabled));
  const [locked, setLocked] = useState(!!(userProfile.user.accountLocked));
  const [superUser, setSuperUser] = useState((isUserASuperUser(userProfile)));

  let roles = [];

  if (userProfile && userProfile.userRoleList) {
     roles = userProfile.userRoleList.map((element) => {
      return {
        label: element.name,
        value: element.id
      }
    });
  }

  roles.unshift(
    {
      label: '',
      value: ''
    }
  );

  let programs = [];

  if (userProfile && userProfile.programList) {
    programs = userProfile.programList.map((element) => {
      return {
        label: element.name,
        value: element.id
      }
    });
  }

  programs.unshift(
    {
      label: '',
      value: ''
    }
  )



  const handleKeyDown = (event) => {
    if(event.key === 'Enter'){
      submitAction(event.target.value);
    }
  }

  const submitAction = () => {
    onSubmitAction(
      {
        email: email,
        firstName: firstName,
        lastName: lastName,
        role: role,
        programAssociation: programAssociation,
        enabled: enabled,
        locked: locked,
        superUser: superUser
      },
      userProfile
    )
  };

  return (
    <UserForm formTitle='User Info' submitAction={submitAction} cancelAction={onCancelAction} submitLabel='Save' disabled={false}>
      <div className='form-required'>
        * Indicates Required Fields
      </div>
      <Input
        name='email'
        id='email'
        value={email}
        label='Email*'
        type='text'
        disabled={true}
        autoComplete='email'
        changeAction={setEmail}
      />
      <Input
        name='firstName'
        id='firstName'
        value={firstName}
        label='First Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='given-name'
        changeAction={setFirstName}
        errors={errors?.firstName}
      />
      <Input
        name='lastName'
        id='lastName'
        value={lastName}
        label='Last Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='family-name'
        changeAction={setLastName}
        errors={errors?.lastName}
      />
      <FormCheckbox
        name='enabled'
        id='enabled'
        value={enabled}
        checked={enabled}
        label='Enabled'
        onKeyDown={handleKeyDown}
        changeAction={setEnabled}
        errors={errors?.enabled}
      />
      <FormCheckbox
        name='locked'
        id='locked'
        value={locked}
        checked={!!locked}
        label='Locked'
        onKeyDown={handleKeyDown}
        changeAction={setLocked}
        errors={errors?.locked}
      />
      <div className="send-invite-link">
        <SendPasswordLink userToSend={userProfile.user} sendResetPasswordAction={sendResetPasswordAction}/>
      </div>
    </UserForm>
  );
}

EditUserProfile.propTypes = {
  errors: PropTypes.object,
  userProfile: PropTypes.object.isRequired,
  onSubmitAction: PropTypes.func.isRequired,
  onCancelAction: PropTypes.func.isRequired
}

export default EditUserProfile;